import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/fe-toolbox'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import BuktiKaryaBlock from '../components/revamp/BuktiKaryaBlock'

import type { FC } from 'react'

interface BuktiKaryaProps {
  categorySlug?: string
}

const BuktiKarya: FC<BuktiKaryaProps> = ({ categorySlug }) => {
  return (
    <>
      <PageHeader />
      <div className="mt-[3.5rem] px-4 py-3 bg-gray-10 h-full--without-header">
        <BuktiKaryaBlock categorySlug={categorySlug} />
      </div>
    </>
  )
}

type PageHeaderProps = {
  title?: string
  onBack?: () => void
}

const PageHeader = ({ onBack }: PageHeaderProps) => {
  const router = useRouter()

  const handleBack = () => {
    historyUtils.backToApp(router.back)
    onBack?.()
  }

  return (
    <HeaderBar fixed className="z-10 py-[1px]">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={handleBack}
      />
      <HeaderBarTitle>Bukti Karya terpilih</HeaderBarTitle>
      <HeaderBarRightAction />
    </HeaderBar>
  )
}

export default BuktiKarya
